import Swal from 'sweetalert2';

const swalWithBootstrapButtons = Swal.mixin({
    buttonsStyling: false,
    customClass: {
        confirmButton: 'btn btn-success m-1',
        cancelButton: 'btn btn-secondary m-1',
        input: 'form-control'
    },
    allowOutsideClick: () => false,
});

export default function useSwal() {
    return swalWithBootstrapButtons;
}